import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  gameShowData,
  gameShowDataTabs,
} from "../../../constants/promotionData";
import SVG_ChevronLeftIcon from "../../../assets/images/svgs/chevronleft.svg?react";
import SVG_ChevronRightIcon from "../../../assets/images/svgs/chevronRight.svg?react";
import { useNavigate } from "react-router-dom";
import { setLoginNew } from "../../../store/LoginNew/loginNew.slice";
import { setLoginNavigationData } from "../../../store/loginNavigation/LoginNavigation.slice";
import { openSlotCasinoPopUp } from "../../../store/slotCasinoPopUp/slotCasinoPopUp.slice";
import { USER_DATA } from "../../../config/app.config";
import { toastr } from "react-redux-toastr";
import { storeUserData } from "../../../helpers/payloadSetter";
import { LeftArrowSVG, RightArrowSVG } from "../../SvgImage/SvgImage";
import { UNICON_THEME } from "../../../config/api.config";

const GameShow = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const [tabIndex, setTabIndex] = useState(0);
  const [showLoginBtn_At, setShowLoginBtn_At] = useState("");

  let userDetail = localStorage.getItem(USER_DATA);
  let userData = JSON.parse(userDetail);

  const scrollRef = useRef(null);

  const handleScrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo({
        left: scrollRef.current.scrollLeft - 150,
        behavior: "smooth",
      });
    }
  };

  const handleScrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo({
        left: scrollRef.current.scrollLeft + 150,
        behavior: "smooth",
      });
    }
  };

  const onClickGame = (item, item_index, tab_Index) => {
    if (auth) {
      if (userData?.is_demo) {
        toastr.error("", "Please login from your read ID.");
        return;
      }
      if (item?.redirect) {
        navigate(item?.redirect);
        // dispatch(setLoginNavigationData({ page: "aviator", ids: [] }));
        return;
      }

      const gameId = item?.gameId;
      const tableId = item?.tableId || null;
      storeUserData(userData?._id, item);
      navigate(`/casino-live/${gameId}/${tableId}`);
      dispatch(openSlotCasinoPopUp());
    } else {
      setShowLoginBtn_At(`${item.name}_${item_index}_${tab_Index}`);
    }
  };

  const handleLogin = (item) => {
    dispatch(setLoginNew(true));
    if (item?.name == "Aviator") {
      dispatch(setLoginNavigationData({ page: "aviator", ids: [] }));
    } else {
      dispatch(
        setLoginNavigationData({
          page: "casino-live",
          ids: [item?.gameId, item?.tableId || null],
        })
      );
    }
  };

  return (
    <div title="Trending Games" className="py-1 px-[6px] w-full">
      <div className="flex flex-col w-full bg-bg_Quaternary rounded-[4px] shadow-homeCasinoCardGamesShadow divide-y">
        <div className="flex items-center justify-between w-full pt-0.5 rounded-t-[4px] px-0.5 bg-bg_Quaternary pr-1">
          <div className=" max-w-[85%] flex items-center justify-start overflow-scroll no-scrollbar">
            {gameShowDataTabs.map((item, index) => {
              return (
                <div
                  className={`cursor-pointer flex active:scale-[97%] items-center justify-start mx-0.5 py-1.5 px-1 rounded-t-[6px] gap-x-0.5 h-full bg-bg_Quaternary border-b-2 ${
                    tabIndex == item.index
                      ? `border-primary ${UNICON_THEME ? "text-red-900" : "bg-bg_text_brand_secondary bg-clip-text text-transparent"}`
                      : "border-transparent text-text_Ternary2"
                  }`}
                  key={`${item.name}_${index}`}
                  onClick={() => {
                    setTabIndex(item.index);
                  }}
                >
                  <span className="text-sm capitalize whitespace-nowrap font-medium">
                    {item.name}
                  </span>
                </div>
              );
            })}
          </div>

          <div className="flex items-center justify-end gap-[5px]">
            <button
              className=" leading-normal relative overflow-hidden  transition duration-150 ease-in-out flex w-[22px] h-[22px] p-1 justify-center items-center gap-[10px] text-text_Primary  bg-bg_Foundation rounded cursor-pointer"
              type="button"
              onClick={() => handleScrollLeft()}
            >
              {/* <SVG_ChevronLeftIcon /> */}
              <LeftArrowSVG />
            </button>
            <button
              className=" leading-normal relative overflow-hidden  transition duration-150 ease-in-out flex w-[22px] h-[22px] p-1 justify-center items-center gap-[10px] text-text_Primary  bg-bg_Foundation rounded cursor-pointer"
              type="button"
              onClick={() => handleScrollRight()}
            >
              {/* <SVG_ChevronRightIcon /> */}
              <RightArrowSVG />
            </button>
          </div>
        </div>

        <div
          id="scrollShow"
          ref={scrollRef}
          className="py-2.5 px-2.5 transition-all ease-in-out duration-200 w-full h-max  overflow-x-auto"
          style={{
            borderColor: "#545454",
          }}
        >
          <div
            className={`grid grid-rows-1 grid-flow-col gap-1 w-max md:w-full min-w-full no-scrollbar`}
          >
            {gameShowData[tabIndex]?.data.map((item, index) => {
              return (
                <div
                  className="min-w-[117px] w-[117px] sm:min-w-[140px] sm:w-[140px] md:min-w-[160px] md:w-[160px]  max-h-[192px] aspect-[0.83] relative"
                  key={`${item.name}_${index}`}
                  onClick={() => {
                    onClickGame(item, index, tabIndex);
                  }}
                >
                  <div className="min-w-[117px] w-[117px] sm:min-w-[140px] sm:w-[140px] md:min-w-[160px] md:w-[160px] flex flex-col  items-start justify-center shadow-GameShadow rounded-[6px]">
                    <div className="relative rounded-[8px] w-full max-h-[192px] aspect-[0.75] overflow-hidden cursor-pointer shadow-sm md:hover:shadow-md">
                      <img
                        src={item.img}
                        width="auto"
                        height="auto"
                        className="w-full h-full transform transition-transform duration-500 ease-in-out hover:scale-105"
                        alt={item.alt}
                        loading="lazy"
                        title={item.title}
                      />
                    </div>
                  </div>

                  {showLoginBtn_At == `${item.name}_${index}_${tabIndex}` && (
                    <div className="absolute bg-bg_Ternary14 shadow-[0 4px 30px rgba(0, 0, 0, 0.1)] w-full h-full text-text_Quaternary text-center flex items-center justify-center z-[100] top-[50%] left-[50%] transform -translate-x-1/2 -translate-y-1/2 backdrop-blur-2">
                      <button
                        className="inline-block  leading-normal relative overflow-hidden  transition duration-150 ease-in-out bg-bg_Quaternary text-text_Secondary px-5 shadow-innerLogin py-1.5 popupAnimation rounded-[16px] text-xs font-lato font-bold cursor-pointer"
                        type="button"
                        onClick={() => {
                          handleLogin(item);
                        }}
                      >
                        Login
                      </button>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GameShow;
